/*
 * @Author: yihao yihao@meiomedical.com
 * @Date: 2025-06-06 16:32:45
 * @LastEditors: yihao yihao@meiomedical.com
 * @LastEditTime: 2025-09-29 09:00:33
 * @FilePath: \website_vue1\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// src/main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/variables.css'


Vue.config.productionTip = false

Vue.use(ElementUI);

new Vue({
    i18n,
  router,
  render: h => h(App)
}).$mount('#app')

